// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "D-DIN";
  src: url('D-DIN.otf');
}
.my-overlay {
  opacity: 1;
  left: 0 !important;
  top: 0 !important;
  z-index: 10000 !important;
  width: 100% !important;
  height: 100% !important;
  position: fixed !important;
  cursor: pointer !important;
  visibility: visible !important;
  transition: visibility 0s, opacity 0.4s linear !important;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.my-overlay p {
  height: 20px;
  font-family: "Montserrat", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 25px;
  line-height: 20px;
  text-align: center;
  color: #000000;
}
.my-overlay p span {
  color: #1ba192;
}
.my-overlay .lds-ellipsis {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}
.my-overlay .lds-ellipsis div {
  position: absolute;
  top: 5px;
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: #1ba192;
  animation-timing-function: cubic-bezier(0, 1, 1, 0);
}
.my-overlay .lds-ellipsis div:nth-child(1) {
  left: 8px;
  animation: lds-ellipsis1 0.6s infinite;
}
.my-overlay .lds-ellipsis div:nth-child(2) {
  left: 8px;
  animation: lds-ellipsis2 0.6s infinite;
}
.my-overlay .lds-ellipsis div:nth-child(3) {
  left: 32px;
  animation: lds-ellipsis2 0.6s infinite;
}
.my-overlay .lds-ellipsis div:nth-child(4) {
  left: 56px;
  animation: lds-ellipsis3 0.6s infinite;
}
@keyframes lds-ellipsis1 {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes lds-ellipsis3 {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(0);
  }
}
@keyframes lds-ellipsis2 {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(24px, 0);
  }
}

.spinner-big {
  font-size: 26px !important;
}

.opacity-20 {
  opacity: 20%;
}

.fa.fa-home:before {
  content: "\\f015";
  color: transparent !important;
  background-image: url(http://localhost:4200/assets/img/icons/icon-dashboard.PNG) !important;
  background-size: 16px 16px !important;
  background-repeat: no-repeat !important;
}`, "",{"version":3,"sources":["webpack://./src/app/app.component.scss"],"names":[],"mappings":"AAAA;EACE,oBAAA;EACA,qBAAA;AACF;AAEA;EACE,UAAA;EACA,kBAAA;EACA,iBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,0BAAA;EACA,0BAAA;EACA,8BAAA;EACA,yDAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AAAF;AAEE;EACE,YAAA;EACA,qCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;AAAJ;AACI;EACE,cAAA;AACN;AAGE;EACE,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;AADJ;AAGI;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,mDAAA;AADN;AAGI;EACE,SAAA;EACA,sCAAA;AADN;AAII;EACE,SAAA;EACA,sCAAA;AAFN;AAKI;EACE,UAAA;EACA,sCAAA;AAHN;AAMI;EACE,UAAA;EACA,sCAAA;AAJN;AAOE;EACE;IACE,mBAAA;EALJ;EAOE;IACE,mBAAA;EALJ;AACF;AAOE;EACE;IACE,mBAAA;EALJ;EAOE;IACE,mBAAA;EALJ;AACF;AAOE;EACE;IACE,0BAAA;EALJ;EAOE;IACE,6BAAA;EALJ;AACF;;AASA;EACE,0BAAA;AANF;;AAQA;EACE,YAAA;AALF;;AAQA;EACE,gBAAA;EACA,6BAAA;EACA,2FAAA;EACA,qCAAA;EACA,uCAAA;AALF","sourcesContent":["@font-face {\n  font-family: \"D-DIN\";\n  src: url(\"../assets/font/d-din/D-DIN.otf\");\n}\n\n.my-overlay {\n  opacity: 1;\n  left: 0 !important;\n  top: 0 !important;\n  z-index: 10000 !important;\n  width: 100% !important;\n  height: 100% !important;\n  position: fixed !important;\n  cursor: pointer !important;\n  visibility: visible !important;\n  transition: visibility 0s, opacity 0.4s linear !important;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n\n  p {\n    height: 20px;\n    font-family: \"Montserrat\", sans-serif;\n    font-style: normal;\n    font-weight: 600;\n    font-size: 25px;\n    line-height: 20px;\n    text-align: center;\n    color: #000000;\n    span {\n      color: #1ba192;\n    }\n  }\n\n  .lds-ellipsis {\n    display: inline-block;\n    position: relative;\n    width: 80px;\n    height: 80px;\n\n    div {\n      position: absolute;\n      top: 5px;\n      width: 9px;\n      height: 9px;\n      border-radius: 50%;\n      background: #1ba192;\n      animation-timing-function: cubic-bezier(0, 1, 1, 0);\n    }\n    div:nth-child(1) {\n      left: 8px;\n      animation: lds-ellipsis1 0.6s infinite;\n    }\n\n    div:nth-child(2) {\n      left: 8px;\n      animation: lds-ellipsis2 0.6s infinite;\n    }\n\n    div:nth-child(3) {\n      left: 32px;\n      animation: lds-ellipsis2 0.6s infinite;\n    }\n\n    div:nth-child(4) {\n      left: 56px;\n      animation: lds-ellipsis3 0.6s infinite;\n    }\n  }\n  @keyframes lds-ellipsis1 {\n    0% {\n      transform: scale(0);\n    }\n    100% {\n      transform: scale(1);\n    }\n  }\n  @keyframes lds-ellipsis3 {\n    0% {\n      transform: scale(1);\n    }\n    100% {\n      transform: scale(0);\n    }\n  }\n  @keyframes lds-ellipsis2 {\n    0% {\n      transform: translate(0, 0);\n    }\n    100% {\n      transform: translate(24px, 0);\n    }\n  }\n}\n\n.spinner-big {\n  font-size: 26px !important;\n}\n.opacity-20 {\n  opacity: 20%;\n}\n\n.fa.fa-home:before {\n  content: \"\\f015\";\n  color: transparent !important;\n  background-image: url(http://localhost:4200/assets/img/icons/icon-dashboard.PNG) !important;\n  background-size: 16px 16px !important;\n  background-repeat: no-repeat !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
